$(function () {
    get_navtab_active();
});

function get_navtab_active() {
    const navTab = $('.navtab');
    const navTabList = navTab.find('ul');
    let tempScrollPosition = 0;
    
    // Function to get the section on scroll
    $(window).on('scroll', function(){
        getActiveSection()
    });

    // Function to get the setion on load
    $(window).on('load', function(){
        getActiveSection()
    })

    // Function to scroll the navtab horizontally to show the active item
    function scrollToActiveNavItem(activeNavItem) {
        if (!activeNavItem || activeNavItem.length === 0) {
            return;
        }
    
        const navTabWidth = navTabList[0].scrollWidth;
        const containerWidth = navTab.width();
        const itemOffsetLeft = activeNavItem.position().left;
        console.log(activeNavItem, itemOffsetLeft);
        
        const itemWidth = activeNavItem.outerWidth();
    
        // Calculate scroll position to center the active item
        const scrollPosition = itemOffsetLeft - (containerWidth/2) + (itemWidth / 2);
    

        // Only animate if the scroll position is different
        if (tempScrollPosition !== scrollPosition) { // Adding tolerance for small pixel differences 
            navTabList.animate({ scrollLeft: scrollPosition }, 100); // Adjust animation speed as needed
        }
        tempScrollPosition = scrollPosition;
    }


    function getActiveSection()
    {
        const scrollPos = $(window).scrollTop();
        
        // Iterate through each section
        $('.section').each(function(){
            const sectionTop = $(this).offset().top - 50; // adjust offset if needed
            const sectionBottom = sectionTop + $(this).outerHeight();

            // Check if the section is in view
            if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
                const sectionId = $(this).attr('id');

                // Remove 'active' class from all nav items
                navTab.find('li').removeClass('active');

                // Add 'active' class to the current nav item
                const activeNavItem = navTab.find(`li[data-section="${sectionId}"]`);
                activeNavItem.addClass('active');

                // Ensure the active item is visible in the navtab
                scrollToActiveNavItem(activeNavItem);
            }
        });
    }

    
}
